var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimplecastByAdsWizzLogoPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 288.1 61.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill-rule: evenodd;      }      .cls-1, .cls-2 {        fill: #0f0f0a;        stroke-width: 0px;      }    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,57.2h53.5V4.2H4v53ZM7.6,53.7h46.3V7.7H7.6v45.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.7,14.8v31.8h32.1L14.7,14.8ZM44.3,37.3l-20.2-20,2.5-2.5,20.2,20-2.5,2.5ZM44.3,27.3l-10.1-10,2.5-2.5,10.1,10-2.5,2.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.9,15.5c-3,0-4.3.8-4.3,2.1s1,1.7,2.6,1.9l7.6.9c4.3.5,6.9,2.3,6.9,6.5s-4.9,7.2-12.4,7.2-11.9-1.5-12.1-7.9h6.9c.2,2.9,2.4,3.5,5.5,3.5s5-.8,5-2.3c0-1.5-1.3-2-3.1-2.2l-6.8-.9c-4.3-.5-6.9-2.2-6.9-6.3s4.9-6.8,11.5-6.8,11.6,1.5,11.8,7.2h-6.9c-.1-2.2-2.2-2.8-5.1-2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.1,
    y: 17.1,
    width: 5.9,
    height: 16.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104 15 104 11.4 110.1 11.4 110.1 15 104 15 104 15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119,19.2h.2c1.5-1.8,4.1-2.5,6.6-2.5s4.8.6,5.9,2.6c1.7-1.9,4.4-2.6,7.1-2.6s6.7,1.9,6.7,6.2v10.5h-5.9v-9c0-2.1-1.3-2.9-3.3-2.9s-4,.8-4,3.8v8.2h-5.9v-9c0-2.1-1.3-2.9-3.3-2.9s-4,.8-4,3.8v8.2h-5.9v-16.3h5.8v2.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.4,
    y: 11.5,
    width: 5.9,
    height: 21.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.1,27.1h6.5c-.5,4-3.3,7-10.9,7s-10.7-3.3-10.7-8.8,3.6-8.8,10.7-8.8,10.3,2.9,10.8,6.9h-6.5c-.2-1.2-1.2-2.5-4.3-2.5s-4.5,1.6-4.5,4.4,1.6,4.4,4.5,4.4,4.1-1.3,4.4-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.4,21.9c-.1-1.3-1.7-1.8-3.9-1.8s-3.1.5-3.1,1.3.4,1,1.8,1.2l6,.7c4,.4,6.1,1.6,6.1,5.2s-3.8,5.6-10.3,5.6-10.2-1.1-10.4-5.9h6.4c.1,1.6,1.4,2.1,4.1,2.1s3.7-.6,3.7-1.5-.6-1.1-2-1.3l-5.5-.7c-3.9-.5-6.2-1.6-6.2-5s4.1-5.3,9.5-5.3,9.9,1.3,10.1,5.5h-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.6,28.9c.6,0,1.5,0,2.3,0v4.6c-.7.1-2.3.3-3.7.3-5,0-6.6-1.3-6.6-5.1v-7.9h-2.8v-3.7h2.8v-4.4h5.9v4.4h4.3v3.7h-4.3v6.7c0,1.1.7,1.4,2,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.7,16.7c-2.7,0-4.8.9-6.2,2.5h-.2v-2.1h-5.8v21.9h5.9v-7.2h.2c1.3,1.4,3.4,2.3,6.1,2.3,5.5,0,9.1-3.1,9.1-8.7s-3.6-8.7-9.1-8.7ZM159,29.7c-3.1,0-4.8-1.7-4.8-4.3s1.7-4.3,4.8-4.3h0c3,0,4.6,1.5,4.6,4.3s-1.6,4.3-4.6,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.3,25.2h0c0-5.5-3.6-8.8-10.8-8.8s-10.8,3.3-10.8,8.8,3.6,8.8,10.8,8.8,10.3-3,10.5-5.7h-6.4c-.2.5-1,1.8-4.1,1.8s-4.3-1.1-4.6-3.4h15.3c0-.4,0-1.1,0-1.5ZM187.1,23.1c.5-1.8,2-2.7,4.4-2.7h0c2.4,0,3.9.9,4.4,2.7h-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.5,30.8v-9.2c0-4.1-3.9-5.1-9.5-5.1s-9.4,1.3-9.5,5.5h6.3c.1-1.2,1.6-1.7,3.3-1.7s3.3.5,3.3,1.3-.6,1.1-1.8,1.2l-6.9.7c-3.2.3-5.4,1.6-5.4,5.2s3.4,5.4,6.9,5.4,5.9-.9,7.5-2.9v.6c0,.8.2,1.4.5,1.7h5.8v-.2c-.4-.5-.5-1.5-.5-2.5ZM241.6,26.3c0,3-3.3,4.1-5.4,4.1s-2.7-.4-2.7-1.8.8-1.7,2.1-1.9l4.3-.7c.6,0,1.3-.2,1.6-.4v.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.5,41.1c-.8,0-1.5.3-2.1.7v-3.3h-1.8v9.8h1.8v-.7c.5.5,1.3.8,2.1.8,2,0,3.6-1.6,3.6-3.7s-1.6-3.7-3.6-3.7ZM81.3,42.8c1.1,0,1.9.8,1.9,2s-.8,2-1.9,2-1.9-.8-1.9-2,.8-2,1.9-2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "88.5 46 86.7 41.2 84.7 41.2 87.5 48.2 86.4 51.1 88.3 51.1 92.3 41.2 90.4 41.2 88.5 46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.5,38.5h-2l-3.8,9.8h2l.9-2.3h3.8l.9,2.3h2l-3.8-9.7h0ZM99.7,44.2h-2.4l1.2-3.2,1.2,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.7,41.8c-.5-.5-1.3-.7-2.1-.7-2,0-3.6,1.6-3.6,3.7s1.6,3.7,3.6,3.7,1.6-.3,2.1-.8v.7h1.8v-9.8h-1.8v3.3ZM108.7,44.8c0,1.1-.8,2-1.9,2s-1.9-.8-1.9-2,.8-2,1.9-2,1.9.8,1.9,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.2,44.1h-.6c-.9-.3-1.2-.4-1.2-.8s.5-.7,1-.7c.7,0,1.1.4,1.1.9h0c0,.1,1.8.1,1.8.1v-.2c0-1.4-1.3-2.4-3-2.4s-2.8.9-2.8,2.2.7,1.9,2.2,2.2h.6c1,.3,1.2.5,1.2.8,0,.6-.8.7-1.1.7-.7,0-1.2-.3-1.3-.9h0c0-.1-1.8-.1-1.8-.1v.2c.1,1.4,1.4,2.4,3.1,2.4s2.9-.9,2.9-2.2-.7-1.9-2.3-2.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "125.7 45.3 127.5 38.5 129.3 38.5 126.7 48.4 124.9 48.4 123.1 42 121.4 48.4 119.6 48.4 116.9 38.5 118.8 38.5 120.5 45.3 122.4 38.5 123.9 38.5 125.7 45.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130,
    y: 41.2,
    width: 1.8,
    height: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.9,38.4c-.6,0-1,.4-1,1s.4,1,1,1,1-.4,1-1-.4-1-1-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.6 42.7 138.7 42.6 138.7 41.2 132.6 41.2 132.6 42.9 136.2 42.9 132.5 47 132.5 48.4 138.7 48.4 138.7 46.6 135.1 46.6 138.6 42.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.8 46.6 145.3 42.7 145.4 42.6 145.4 41.2 139.3 41.2 139.3 42.9 142.9 42.9 139.2 47 139.2 48.4 145.4 48.4 145.4 46.6 141.8 46.6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplecastByAdsWizzLogoPrimary);
export default __webpack_public_path__ + "static/media/SimplecastByAdsWizz-Logo-Primary.6446cedb.svg";
export { ForwardRef as ReactComponent };